(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    // highlight active tab on hover
    const tabs = document.querySelectorAll('.mega-menu-tabs li');
    tabs.forEach((tab) => {
      tab.addEventListener('mouseenter', () => {
        tabs.forEach((t) => t.classList.remove('active-tab'));
        tab.classList.add('active-tab');
      });
    });

    // persistent mega menu hover
    const detailsEls = document.querySelectorAll('details.mega-menu');
    detailsEls.forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.mega-menu-content-div'); // dropdown content
      let timer;

      // open on hover of summary
      summary.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        details.setAttribute('open', true);
      });

      // keep open when inside content
      content.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        details.setAttribute('open', true);
      });

      // close only when leaving the whole menu area
      details.addEventListener('mouseleave', () => {
        timer = setTimeout(() => {
          details.removeAttribute('open');
        }, 150);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
